import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MunichIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                "clip-path": "url(#clip0_1529_9463)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M13.592 10.3462H7.10059V20.0834H8.95496V16.8375C8.95496 16.0693 9.57774 15.4465 10.346 15.4465C11.1142 15.4465 11.737 16.0693 11.737 16.8375V20.0834H13.592V10.3462Z",
                        fill: "#FDAB3D"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M3.8546 2.46368C3.8546 2.20759 4.06219 2 4.31827 2C4.57435 2 4.78195 2.20759 4.78195 2.46368V3.39103C4.78195 3.40648 4.78119 3.42175 4.77972 3.43682C5.83912 3.65071 6.63679 4.58685 6.63679 5.7093V7.564V12.2008V20.0832H2.00004V12.2008V7.564V5.7093C2.00004 4.58695 2.79757 3.65087 3.85684 3.43687C3.85536 3.42179 3.8546 3.4065 3.8546 3.39103V2.46368ZM15.9127 3.43675C14.8532 3.6505 14.0553 4.58673 14.0553 5.7093V7.564V12.2008V20.0832H18.6921V12.2008V7.564V5.7093C18.6921 4.58707 17.8947 3.65107 16.8356 3.43694C16.8371 3.42184 16.8379 3.40652 16.8379 3.39103V2.46368C16.8379 2.20759 16.6303 2 16.3742 2C16.1181 2 15.9105 2.20759 15.9105 2.46368V3.39103C15.9105 3.40645 15.9113 3.42171 15.9127 3.43675Z",
                        fill: "#FDAB3D"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1529_9463",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
